import MainLayout from "../layouts/MainLayout";
import PageTitle from '../components/UtilityHelpers/PageTitle';

import { useAuth } from "../hooks/useAuth";

import AdminDashboard from "../components/Dashboard/AdminDashboard";
import PurchaserDashboard from "../components/Dashboard/PurchaserDashboard";
import ApproverDashboard from "../components/Dashboard/ApproverDashboard";
import RequestorDashboard from "../components/Dashboard/RequestorDashboard";
import LimitedOpexApproverDashboard from "../components/Dashboard/LimitedOpexApproverDashboard";

import { Navigate } from 'react-router-dom';


const HomePage = () => {
    const auth = useAuth();

    const switcher = () => {
        if (auth?.roles?.find(role => ["500"]?.includes(role))) {
            return <AdminDashboard />
        }

        if (auth?.roles?.find(role => ["400"]?.includes(role))) {
            return <PurchaserDashboard />
        }        

        if (auth?.roles?.find(role => ["300"]?.includes(role))) {
            return <ApproverDashboard />
        }

        if (auth?.roles?.find(role => ["200"]?.includes(role))) {
            return <LimitedOpexApproverDashboard />
        }

        if (auth?.roles?.find(role => ["100"]?.includes(role))) {
            return <Navigate to="/request" replace />
        }
    }


    return (
        <>
            <PageTitle title="OPS | HomePage" />
            <MainLayout>
                
            { switcher() }

            </MainLayout>
        </>
    )
}

export default HomePage;